import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/denntenna.github.io/denntenna.github.io/src/components/default-mdx-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Teen Couple Have Fun Outdoors`}</h1>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "373px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/aee25f9ae7cabf93db840cab2d7e2073/67a5d/rn-cover-tchfo.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "161%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,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')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Book Cover",
            "title": "Book Cover",
            "src": "/static/aee25f9ae7cabf93db840cab2d7e2073/67a5d/rn-cover-tchfo.png",
            "srcSet": ["/static/aee25f9ae7cabf93db840cab2d7e2073/5a46d/rn-cover-tchfo.png 300w", "/static/aee25f9ae7cabf93db840cab2d7e2073/67a5d/rn-cover-tchfo.png 373w"],
            "sizes": "(max-width: 373px) 100vw, 373px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`A quick paced read about a family that has to come to terms with a sex tape featuring their elder son. Funny in parts.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      